import { useNavigate } from 'react-router-dom';
import {
  ExclamationTriangleIcon,
  ArrowLeftIcon,
  HomeIcon
} from '@heroicons/react/24/outline';

export default function PageNotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4">
      <div className="text-center space-y-6 max-w-lg">
        <ExclamationTriangleIcon className="h-24 w-24 mx-auto" />

        <h1 className="text-9xl font-bold text-ghost">404</h1>

        <div className="space-y-2">
          <h2 className="text-2xl font-semibold">Page Not Found</h2>
          <p className="text-base-content/60">
            Oops! The page you&apos;re looking for doesn&apos;t exist or has
            been moved.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 justify-center pt-4">
          <button onClick={() => navigate(-1)} className="btn btn-ghost gap-2">
            <ArrowLeftIcon className="h-5 w-5" />
          </button>
          <button onClick={() => navigate('/')} className="btn btn-ghost gap-2">
            <HomeIcon className="h-5 w-5" />
          </button>
        </div>
      </div>
    </div>
  );
}
